import Portal, {RefreshTokenCreatedEvent} from "@/managers/portal"
import JwtAuthenticationMethod, {Token} from "@/managers/authentication/jwtAuthenticationMethod"
import Notifications from "@/managers/session/notifications"
import {OfflineHandledCall} from "@/utility/offlineHandledCall"

class RefreshToken extends JwtAuthenticationMethod {
	constructor() {
		super(localStorage, "RefreshToken", true)

		Portal.client.addEventListener(RefreshTokenCreatedEvent.eventName, event => {
			const rawToken = (event as RefreshTokenCreatedEvent).token

			if (rawToken !== null) {
				if (!this.isLoggingIn)
					this.validateAndSetToken(new Token(rawToken))
			} else
				this.clear()
		})
	}

	protected handleTokenExpiry(token: Token): Promise<void> {
		// Don't clear the token on local expiry: another tab may be mid-rotation, the server is the authoritative source. Let the next login attempt decide
		Notifications?.debug(`Refresh token expired, keeping in storage until used: ${token.shortRaw}`)
		return Promise.resolve()
	}

	protected deleteToken(rawToken: string): void {
		Notifications?.debug("Deleting refresh token")
		Portal.call.tokens.refreshDelete(rawToken).response
			.catch(error => Notifications.debug(`Failed to delete refresh token: ${error.message}`))
	}

	protected async loginWithToken(token: string): Promise<string | null> {
		try {
			const tokens = await OfflineHandledCall(() => Portal.call.tokens.post(token).response)
			return tokens.Refresh
		} catch (error: any) {
			Notifications.debug(`Failed to login with refresh token: ${error.message}`)
			throw error
		}
	}
}

export default new RefreshToken()
